import React from "react";

export default function Footer() {
  return (
    <div className="Footer">
      <p>
        {" "}
        This project is coded by Akxa Alex and is open-sourced on{" "}
        <a
          href="https://github.com/akxaalex16/react-weather"
          target="_blank"
          rel="noreferrer"
        >
          GitHub,
        </a>
        <br />
        hosted on{" "}
        <a
          href="https://friendly-clarke-aa1415.netlify.app"
          target="_blank"
          rel="noreferrer"
        >
          Netlify{" "}
        </a>
      </p>
    </div>
  );
}
